<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShield_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M7.6 15c-1.622-.408-2.96-1.339-4.016-2.791C2.528 10.756 2 9.143 2 7.37V3.1L7.6 1l5.6 2.1v4.27c0 1.773-.528 3.386-1.584 4.839C10.56 13.66 9.222 14.592 7.6 15Z"
    />
</svg>
